import validate from 'validate.js';

const constraints = {
  nombre: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
  tipo: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
  icono: {
    presence: {
      allowEmpty: false,
      message: 'es obligatorio'
    }
  },
};

export const validaMotivo = motivo => (
    (motivo ? validate(motivo, constraints) : {}) || {}
);